import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { apiError, isIndia } from "@/lib/campus";

const loadScript = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(true);
  s.onerror = () => resolve(false);
  document.body.appendChild(s);
});

export const RazorpayButton = ({ courseId, onPaid }) => {
  const [cfg, setCfg] = useState(null);
  const [inr, setInr] = useState(null);
  const [show, setShow] = useState(isIndia());

  useEffect(() => {
    api.get("/payments/razorpay/config").then(({ data }) => setCfg(data)).catch(() => {});
    api.get(`/courses/${courseId}/inr-price`).then(({ data }) => setInr(data.inr)).catch(() => {});
  }, [courseId]);

  if (!cfg?.enabled) return null;
  if (!show)
    return <button type="button" data-testid="rzp-reveal" onClick={() => setShow(true)} className="w-full text-xs text-slate-500 hover:text-amber-300 mt-3">In India? Pay in ₹ with UPI</button>;

  const pay = async () => {
    try {
      const { data } = await api.post(`/courses/${courseId}/razorpay/order`);
      if (!(await loadScript())) return toast.error("Couldn't load Razorpay");
      new window.Razorpay({
        key: data.key_id, amount: data.amount, currency: "INR", order_id: data.order_id, name: "Hustler's Campus",
        description: data.course_title, prefill: data.prefill, theme: { color: "#F59E0B" },
        handler: async (r) => {
          try { await api.post("/payments/razorpay/verify", r); toast.success("Paid — lessons unlocked"); onPaid?.(); }
          catch (err) { toast.error(apiError(err, "Payment verification failed")); }
        },
      }).open();
    } catch (err) {
      toast.error(apiError(err, "Couldn't start Razorpay"));
    }
  };

  return (
    <button type="button" data-testid="rzp-pay-btn" onClick={pay}
      className="w-full mt-3 border border-white/15 hover:border-amber-500/60 text-white font-semibold py-2.5 rounded-xl text-sm transition-colors">
      Pay ₹{inr ?? "…"} with UPI / Razorpay (India)
    </button>
  );
};
